import { jsx as _jsx } from "react/jsx-runtime";
import useTournamentsV2Designs from '@domain/Tournament/hooks/useTournamentV2Designs';
const withTournamentV2 = (Component, ComponentV2) => ({ forceV1 = false, ...props }) => {
    const shouldRenderV2 = useTournamentsV2Designs(props === null || props === void 0 ? void 0 : props.gameKey) && !forceV1;
    return shouldRenderV2 ? _jsx(ComponentV2, { ...props }) : _jsx(Component, { ...props });
};
export default withTournamentV2;
